


































































import Vue from 'vue';
import Component from 'vue-class-component';
import Reservation from '@/models/Reservation';
import Service from '@/models/Service';
import { stringOrBlank } from '@/utilities/helpers';

const Setup = Vue.extend({
	props: {
		alwaysPopover: Boolean,
		selectable: Boolean,
		selected: Boolean,
		service: Object,
	},
});

@Component
export default class ReservationService extends Setup {
	// Props
	public alwaysPopover!: boolean;
	public selectable!: boolean;
	public selected!: boolean;
	public service!: Service;

	// Computed
	public get popoverIcon(): [string, string] {
		return this.alwaysPopover
			? ['fas', 'info-circle']
			: ['fas', 'chevron-circle-right'];
	}

	public get reservation(): Reservation {
		return this.$store.state.reservation.reservation;
	}

	public get serviceName(): string {
		return stringOrBlank(this.service.ws_description || this.service.description);
	}

	public get serviceDescription(): string {
		return stringOrBlank(this.service.ws_notes || this.service.notes);
	}

	// Methods
	public toggleSelected(event: any) {
		if (event.target.classList && event.target.classList.contains('np-service__info')) {
			return false;
		}

		return this.selectable
			? this.$emit('change', this.service)
			: false;
	}
}
